import { Component, OnInit } from '@angular/core';
import {Student} from '../../model/student';
import {AppSettings} from '../../../app-settings';
import {ActivatedRoute} from '@angular/router';
import {DataManagementService} from '../../services/data-management.service';
import {AuthenticationService} from '../../services/authentication.service';
import {Constants} from '../../constants';
import {RoundNameConstants} from '../../round-name-constants';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-practice-round-reports',
  templateUrl: './practice-round-reports.component.html',
  styleUrls: ['./practice-round-reports.component.css']
})
export class PracticeRoundReportsComponent implements OnInit {

  dtTrigger: Subject<string> = new Subject();
  dtOptions: DataTables.Settings = {};
  filter_id;
  title;
  token;
  students: Student[];
  rounds = [];
  outgoingRoundId = '0';
  outgoingTermId = '0';
  downloadPracticeRoundBiddingResultsExcel = AppSettings.DOWNLOAD_ROUND_WISE_BIDDING_RESULTS;
  downloadPracticeRoundProcessingResultsExcel = AppSettings.DOWNLOAD_ROUND_WISE_PROCESSING_OUTPUT;
  downloadPracticeRoundPreferencesExcel = AppSettings.DOWNLOAD_PRACTICE_ROUND_UNIVERSITY_PREFERENCES;
  downloadPracticeRoundAllotmentReport = AppSettings.DOWNLOAD_OUTGOING_PRACTICE_ROUND_ALLOTMENT_REPORT;
  selectUndefinedOptionValue = '0';
  processingOutput = [];
  practiceRoundPreferences = [];
  practiceRoundUniversityWiseAllotment = [];
  rowGroupMetadata: any;
  biddingResults = [];
  errorMessage;

  constructor(private route: ActivatedRoute,
              private dmService: DataManagementService,
              private authenticationService: AuthenticationService) { }

  getAllRounds(): void {
    this.dmService.getAll(Constants.ROUND_SETTINGS)
        .subscribe(
            response => {
              if (response.status === 'success') {
                // this.rounds = response.data;
                for (let i = 0; i < response.data.length; i++) {
                  if (response.data[i].outgoing_round_name_id === parseInt(RoundNameConstants.PRACTICE_BIDDING_ROUND, 10)) {
                    this.rounds.push(response.data[i]);
                  }
                }
                if (this.rounds.length > 0) {
                  this.outgoingRoundId = this.rounds[0].outgoing_round_id;
                  this.outgoingTermId = this.rounds[0].outgoing_term_id;
                }
                if (this.filter_id === 1) {
                  this.getPracticeRoundUniversityPreferences();
                } else if (this.filter_id === 2) {
                  this.getProcessingReport();
                } else if (this.filter_id === 3) {
                  this.getBiddingResponse();
                } else if (this.filter_id === 4) {
                  this.getPracticeRoundUniversityAllotment();
                }
              }
            },
            error => {
              console.log(error);
              this.errorMessage = 'Server Error';
              // this.errorMessage = error;
            });
  }

  getBiddingResponse(): void {
    this.dmService.getOne(Constants.BIDDING_RESPONSE_REPORT, this.outgoingRoundId)
        .subscribe(
            response => {
              if (response.status === 'success') {
                this.biddingResults = response.data;
                if (this.biddingResults.length <= 0) {
                  this.errorMessage = 'There is no data available for Bidding Result.';
                } else {
                  this.dtTrigger.next();
                }
              } else if (response.status === 'fail') {
                if (response.data.hasOwnProperty('message')) {
                  this.errorMessage = response.data.message;
                } else {
                  this.errorMessage = 'Something went wrong. Please contact support team';
                }
              }
            },
            error => {
              console.log(error);
              this.errorMessage = 'Server Error';
              // this.errorMessage = error;
            });
  }

  getProcessingReport(): void {
    this.dmService.getOne(Constants.PROCESSING_OUTPUT_REPORT, this.outgoingRoundId)
        .subscribe(
            response => {
              if (response.status === 'success') {
                this.processingOutput = response.data;
                if (this.processingOutput.length <= 0) {
                  this.errorMessage = 'There is no data available for Bidding Processing.';
                } else {
                  this.dtTrigger.next();
                }
              } else if (response.status === 'fail') {
                if (response.data.hasOwnProperty('message')) {
                  this.errorMessage = response.data.message;
                } else {
                  this.errorMessage = 'Something went wrong. Please contact support team';
                }
              }
            },
            error => {
              console.log(error);
              this.errorMessage = 'Server Error';
              // this.errorMessage = error;
            });
  }

  getPracticeRoundUniversityPreferences(): void {
    this.dmService.getOne(Constants.PRACTICE_ROUND_UNIVERSITY_PREFERENCES, this.outgoingTermId)
        .subscribe(
            response => {
              if (response.status === 'success') {
                this.practiceRoundPreferences = response.data;
                if (this.practiceRoundPreferences.length === 0) {
                  this.errorMessage = 'There is no data available for practice round preferences.';
                } else {
                  this.dtTrigger.next();
                }
              } else if (response.status === 'fail') {
                if (response.data.hasOwnProperty('message')) {
                  this.errorMessage = response.data.message;
                } else {
                  this.errorMessage = 'Something went wrong. Please contact support team';
                }
              }
            },
            error => {
              console.log(error);
              this.errorMessage = 'Server Error';
              // this.errorMessage = error;
            });
  }

  getPracticeRoundUniversityAllotment(): void {
    this.dmService.getOne(Constants.PRACTICE_ROUND_UNIVERSITY_WISE_ALLOTMENT, this.outgoingTermId)
        .subscribe(
            response => {
              if (response.status === 'success') {
                this.practiceRoundUniversityWiseAllotment = response.data;
                if (this.practiceRoundUniversityWiseAllotment.length === 0) {
                  this.errorMessage = 'There is no data available for practice round university wise allotment.';
                } else {
                  this.updateRowGroupMetaData();
                }
              } else if (response.status === 'fail') {
                if (response.data.hasOwnProperty('message')) {
                  this.errorMessage = response.data.message;
                } else {
                  this.errorMessage = 'Something went wrong. Please contact support team';
                }
              }
            },
            error => {
              console.log(error);
              this.errorMessage = 'Server Error';
              // this.errorMessage = error;
            });
  }

  updateRowGroupMetaData() {
    this.rowGroupMetadata = {};
    if (this.practiceRoundUniversityWiseAllotment) {
      for (let i = 0; i < this.practiceRoundUniversityWiseAllotment.length; i++) {
        const rowData = this.practiceRoundUniversityWiseAllotment[i];
        const universityNameWithSeats = rowData.university_name_with_seats ;
        if (i === 0) {
          this.rowGroupMetadata[universityNameWithSeats] = { index: 0, size: 1 };
        } else {
          const previousRowData = this.practiceRoundUniversityWiseAllotment[i - 1];
          const previousRowGroup = previousRowData.university_name_with_seats;
          if (universityNameWithSeats === previousRowGroup) {
            this.rowGroupMetadata[universityNameWithSeats].size++;
          } else {
            this.rowGroupMetadata[universityNameWithSeats] = { index: i, size: 1 };
          }
        }
      }
    }
  }

  termChange() {
    if (this.filter_id === 1) {
      this.getPracticeRoundUniversityPreferences();
    } else if (this.filter_id === 2) {
      this.getProcessingReport();
    } else if (this.filter_id === 3) {
      this.getBiddingResponse();
    } else if (this.filter_id === 4) {
      this.getPracticeRoundUniversityAllotment();
    }
  }

  ngOnInit() {
    this.getAllRounds();
    this.token = '?token=' + this.authenticationService.getToken();
    this.route
        .params
        .subscribe(params => {
          this.filter_id = parseInt(params['id'], 10);
        });
    if (this.filter_id === 1) {
      this.title = 'Practice Round Student University Preferences';
    } else if (this.filter_id === 2) {
      this.title = 'Bidding Processing Report';
    } else if (this.filter_id === 3) {
      this.title = 'Bidding Result Report';
    } else if (this.filter_id === 4) {
      this.title = 'Practice Round University-wise Allotment Report';
    }
    this.dtOptions = {
      paging: true,
      retrieve: true,
      destroy: true,
      lengthChange: true,
      info: false
    };
  }

}
